let runtimeConfig: { env: Record<string, string>; [key: string]: any } = { env: {} };

export const setRuntimeConfig = (key: string, value: string) => {
  runtimeConfig[key] = value;
};

export const getRuntimeConfig = () => runtimeConfig;
